var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"images-group-1",style:({..._vm.fullPaddingSubject(_vm.section.options.customize.style), ..._vm.fullMarginSubject(_vm.section.options.customize.style)})},[_c('div',{staticClass:"d-inline-block position-relative"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }